var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoundedArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 0 24)",
    fill: "#FFEDE0",
    fillOpacity: 0.56
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 23.75,
    width: 23.5,
    height: 23.5,
    rx: 11.75,
    transform: "rotate(-90 0.25 23.75)",
    stroke: "#F5EFEB",
    strokeOpacity: 0.32,
    strokeWidth: 0.5,
    style: {
      mixBlendMode: "luminosity"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9475 12.0009L9.44973 7.46527C9.11683 7.12914 9.11683 6.58702 9.44973 6.25089C9.60836 6.09032 9.82473 6 10.0504 6C10.2761 6 10.4924 6.09032 10.6511 6.25089L15.7495 11.3928C16.0835 11.7286 16.0835 12.2714 15.7495 12.6072L10.6513 17.7491C10.4924 17.9097 10.2761 18 10.0504 18C9.82473 18 9.60836 17.9097 9.44952 17.7491C9.11683 17.4129 9.11683 16.8708 9.44995 16.5347L13.9475 12.0009Z",
    fill: "#090909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundedArrowRight);
export default __webpack_public_path__ + "static/media/iconRoundedArrowRight.343044f9f5e65a9570b986a216936463.svg";
export { ForwardRef as ReactComponent };